import React from 'react'
import { Link } from "react-router-dom";

function ChairmanMessage() {
    return (
        <>
            <div className="innerslide py-3 bg-light border-bottom">
                <ul className="breadcrumb container mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>{" "}
                    <li className="breadcrumb-item active"> Leadership</li>
                    <li className="breadcrumb-item active">  Chairman's Message </li>
                </ul>
            </div>
            <div className="innersec container my-5 founder_message">
                <div className="row">
                    <div class="col-lg-12">
                        <h1>  Chairman's Message </h1>
                    </div>
                    <div className="col-lg-12">
                        <>
                            <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/David_Hilton.jpg"
                                className="col-md-4 float-md-end left-img img-fluid"
                                alt="thefrankanthonyjuniorschoolblr" />
                            <p>
                                coming soon...
                            </p>
                            <br />
                            <div className="mesdeskimg">
                                <h3> Mr. David J. Hilton</h3>
                                <h5>President/Chairman</h5>
                                {/* <h5>25th September, 1908 – 2nd December, 1993 </h5> */}
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChairmanMessage